function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Transaction = require('../../lib/saito/transaction')["default"];
var index = require('./index');
var BugsDatabase = require('./lib/database');
var BugsMain = require('./lib/main');
var BugEditor = require('./lib/overlays/bug-editor');
var RedSquareBridge = require('./lib/redsquare');
var _require = require('./lib/constants'),
  COMPLETED_RETENTION_MS = _require.COMPLETED_RETENTION_MS,
  DEFAULT_WEIGHT = _require.DEFAULT_WEIGHT,
  STATUS_LABELS = _require.STATUS_LABELS;
var _require2 = require('./lib/ordering'),
  midpointWeight = _require2.midpointWeight,
  shouldApplyEvent = _require2.shouldApplyEvent;
var _require3 = require('./lib/policy'),
  canCreateBug = _require3.canCreateBug,
  canUpdateBug = _require3.canUpdateBug,
  returnPolicy = _require3.returnPolicy;
var _require4 = require('./lib/signature'),
  verifyTransactionSignatureHash = _require4.verifyTransactionSignatureHash;
var _require5 = require('./lib/validation'),
  containsBugHashtag = _require5.containsBugHashtag,
  isRootTweetMessage = _require5.isRootTweetMessage,
  validateBugsMessage = _require5.validateBugsMessage;
var Bugs = /*#__PURE__*/function (_ModTemplate) {
  function Bugs(app) {
    var _this;
    _classCallCheck(this, Bugs);
    _this = _callSuper(this, Bugs, [app]);
    _this.app = app;
    _this.name = 'Bugs';
    _this.slug = 'bugs';
    _this.appname = 'Bugs';
    _this.description = 'Transaction-driven bug tracking over RedSquare threads';
    _this.categories = 'Utilities Development';
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.icon_fa = 'fa-solid fa-bug';
    _this.possibleHome = 0;
    _this.styles = ['/saito/saito.css', '/redsquare/style.css', '/bugs/style.css'];
    _this.completedRetentionMs = COMPLETED_RETENTION_MS;
    _this.clientBugs = new Map();
    _this.discoveredCandidates = new Map();
    _this.maxDiscoveredCandidates = 500;
    _this.pendingEvents = new Map();
    _this.maxPendingEvents = 2000;
    _this.maxClientEventsPerBug = 500;
    _this.processing = new Map();
    _this.autoCapturePending = new Set();
    _this.database = null;
    _this.redsquare = null;
    _this.main = null;
    _this.editor = null;
    _this.header = null;
    _this.serverPeer = '';
    _this.restored = false;
    _this.restoring = false;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: 'Saito Bugs',
      url: '/bugs',
      description: _this.description,
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card.png'
    });
    return _this;
  }
  _inherits(Bugs, _ModTemplate);
  return _createClass(Bugs, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Bugs, "initialize", this, 3)([app]);
            case 1:
              this.redsquare = new RedSquareBridge(app, this);
              if (app.BROWSER) {
                this.editor = new BugEditor(app, this);
                this.main = new BugsMain(app, this);
              } else {
                this.database = new BugsDatabase(app, this);
                setTimeout(function () {
                  return _this2.restoreProjection()["catch"](function (err) {
                    return console.error('[Bugs] restore failed', err);
                  });
                }, 0);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.enableForUser();
            case 2:
              if (this.header) {
                _context2.n = 4;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context2.n = 3;
              return this.header.initialize(this.app);
            case 3:
              this.addComponent(this.header);
            case 4:
              _context2.n = 5;
              return _superPropGet(Bugs, "render", this, 3)([this.app, this]);
            case 5:
              _context2.n = 6;
              return this.main.render();
            case 6:
              if (new URLSearchParams(window.location.search).get('create') === '1') {
                window.history.replaceState({}, '', '/bugs');
                this.editor.open('create');
              }
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "enableForUser",
    value: function () {
      var _enableForUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$app, _this$app$options;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              (_this$app = this.app).options || (_this$app.options = {});
              (_this$app$options = this.app.options).bugs || (_this$app$options.bugs = {});
              if (!(this.app.options.bugs.enabled === true)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, false);
            case 1:
              this.app.options.bugs.enabled = true;
              _context3.n = 2;
              return this.app.storage.saveOptions();
            case 2:
              this.app.connection.emit('saito-header-update-message', {
                msg: 'Bugs has been added to your applications',
                timeout: 2500
              });
              return _context3.a(2, true);
          }
        }, _callee3, this);
      }));
      function enableForUser() {
        return _enableForUser.apply(this, arguments);
      }
      return enableForUser;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var _this$app$options2;
      return ((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.bugs) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.enabled) === true;
    }
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var _this3 = this;
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'saito-header') {
        if (!this.isEnabled() || this.browser_active) return [];
        return [{
          text: 'Bugs',
          icon: this.icon_fa,
          rank: 95,
          type: 'navigation',
          callback: function callback() {
            return navigateWindow('/bugs');
          }
        }];
      }
      if (type === 'redsquare-create' && this.isEnabled()) {
        return {
          id: 'bugs-create',
          label: 'Create Bug',
          icon: this.icon_fa,
          callback: function callback() {
            if (_this3.editor) _this3.editor.open('create');else navigateWindow('/bugs?create=1');
          }
        };
      }

      // This response is ready for the extension point specified in docs/todo.md.
      if (type === 'redsquare-tweet-menu' && this.isEnabled()) {
        return {
          id: 'bugs-capture',
          text: 'Capture as Bug',
          icon: this.icon_fa,
          callback: function callback(context) {
            return _this3.openCapture(context);
          }
        };
      }
      if (type === 'bugs-api') {
        return {
          capture: function capture(context) {
            return _this3.openCapture(context);
          },
          isTracked: function isTracked(rootTxSig) {
            var _this3$clientBugs$get;
            return ((_this3$clientBugs$get = _this3.clientBugs.get(rootTxSig)) === null || _this3$clientBugs$get === void 0 ? void 0 : _this3$clientBugs$get.tracked) === 1;
          },
          open: function open(rootTxSig) {
            return navigateWindow("/bugs/".concat(encodeURIComponent(rootTxSig)));
          }
        };
      }
      return null;
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      if (this.app.BROWSER) return [];
      return [this.app.network.createPeerService(null, 'bugs', 'Bugs Workflow Projection')];
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var service,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              if (app.BROWSER) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(service.service === 'redsquare')) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.redsquare.registerPeer(peer);
            case 2:
              if (!this.browser_active) {
                _context4.n = 3;
                break;
              }
              _context4.n = 3;
              return this.main.refreshCurrentView();
            case 3:
              if (!(service.service === 'bugs')) {
                _context4.n = 4;
                break;
              }
              this.serverPeer || (this.serverPeer = peer.publicKey);
              if (!this.browser_active) {
                _context4.n = 4;
                break;
              }
              _context4.n = 4;
              return this.main.refreshCurrentView();
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerServiceUp(_x2, _x3) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(moduleName) {
      return moduleName === this.name || moduleName === 'RedSquare' ? 1 : 0;
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(blk, tx, conf) {
        var message;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(Number(conf) !== 0)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              message = tx.returnMessage();
              if (!(message.module === this.name)) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return this.processBugsTransaction(tx, this.blockContext(blk, tx));
            case 2:
              _context5.n = 4;
              break;
            case 3:
              if (!(message.module === 'RedSquare' && message.request === 'create tweet')) {
                _context5.n = 4;
                break;
              }
              _context5.n = 4;
              return this.processRedSquareTransaction(tx);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onConfirmation(_x4, _x5, _x6) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "blockContext",
    value: function blockContext(blk, tx) {
      var transactions = (blk === null || blk === void 0 ? void 0 : blk.transactions) || [];
      var ordinal = transactions.findIndex(function (candidate) {
        return candidate.signature === tx.signature;
      });
      return {
        block_id: Number((blk === null || blk === void 0 ? void 0 : blk.id) || 0),
        tx_ordinal: ordinal < 0 ? 0 : ordinal,
        confirmed: true,
        blk: blk
      };
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, tx, peer) {
        var callback,
          message,
          _message$data,
          inner,
          result,
          _message$data2,
          _args6 = arguments,
          _t,
          _t2,
          _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              callback = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : null;
              message = tx.returnMessage();
              if (!(message.request === 'bugs transaction')) {
                _context6.n = 6;
                break;
              }
              _context6.p = 1;
              inner = new Transaction();
              inner.deserialize_from_web(app, (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.transaction);
              if (this.verifyTransactionSignature(inner)) {
                _context6.n = 2;
                break;
              }
              throw new Error('Invalid inner transaction signature');
            case 2:
              _context6.n = 3;
              return this.processBugsTransaction(inner, {
                direct: true
              });
            case 3:
              result = _context6.v;
              callback === null || callback === void 0 || callback(result);
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t = _context6.v;
              callback === null || callback === void 0 || callback({
                accepted: false,
                error: _t.message || String(_t)
              });
            case 5:
              return _context6.a(2, 1);
            case 6:
              if (!(message.request === 'bugs query' && !app.BROWSER && callback)) {
                _context6.n = 8;
                break;
              }
              _t2 = callback;
              _context6.n = 7;
              return this.database.listBugs(message.data || {});
            case 7:
              _t2(_context6.v);
              return _context6.a(2, 1);
            case 8:
              if (!(message.request === 'bugs get' && !app.BROWSER && callback)) {
                _context6.n = 10;
                break;
              }
              _t3 = callback;
              _context6.n = 9;
              return this.database.getBug(String(((_message$data2 = message.data) === null || _message$data2 === void 0 ? void 0 : _message$data2.root_tx_sig) || '').slice(0, 128));
            case 9:
              _t3(_context6.v);
              return _context6.a(2, 1);
            case 10:
              return _context6.a(2, _superPropGet(Bugs, "handlePeerTransaction", this, 3)([app, tx, peer, callback]));
          }
        }, _callee6, this, [[1, 4]]);
      }));
      function handlePeerTransaction(_x7, _x8, _x9) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "verifyTransactionSignature",
    value: function verifyTransactionSignature(tx) {
      try {
        var signer = this.returnSigner(tx);
        if (typeof this.app.crypto.verifyHashSignature === 'function') {
          return Boolean(signer && tx.signature && this.app.crypto.verifyHashSignature(tx.getHashForSignature(), tx.signature, signer));
        }
        return verifyTransactionSignatureHash(tx, signer);
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "returnSigner",
    value: function returnSigner(tx) {
      var _tx$from, _tx$from2;
      return (tx === null || tx === void 0 || (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || (tx === null || tx === void 0 || (_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publickey) || '';
    }
  }, {
    key: "returnTimestamp",
    value: function returnTimestamp(tx) {
      var _tx$timestamp;
      var timestamp = Number((_tx$timestamp = tx === null || tx === void 0 ? void 0 : tx.timestamp) !== null && _tx$timestamp !== void 0 ? _tx$timestamp : tx === null || tx === void 0 ? void 0 : tx.ts);
      return Number.isSafeInteger(timestamp) && timestamp > 0 ? timestamp : Date.now();
    }
  }, {
    key: "authorityPolicy",
    value: function authorityPolicy() {
      // The module public key is the node administrator only on the server. A
      // browser wallet must not silently grant itself administrator authority.
      return returnPolicy(this.app, this.app.BROWSER ? '' : this.publicKey);
    }
  }, {
    key: "processBugsTransaction",
    value: function () {
      var _processBugsTransaction2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(tx) {
        var _this4 = this;
        var context,
          result,
          task,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              context = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              if (tx !== null && tx !== void 0 && tx.signature) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, {
                accepted: false,
                error: 'Unsigned Bugs transaction'
              });
            case 1:
              if (!this.processing.has(tx.signature)) {
                _context7.n = 4;
                break;
              }
              _context7.n = 2;
              return this.processing.get(tx.signature);
            case 2:
              result = _context7.v;
              if (!(Number(context.block_id || 0) > 0)) {
                _context7.n = 3;
                break;
              }
              return _context7.a(2, this.processBugsTransaction(tx, context));
            case 3:
              return _context7.a(2, result);
            case 4:
              this.pendingEvents["delete"](tx.signature);
              task = this._processBugsTransaction(tx, context)["finally"](function () {
                return _this4.processing["delete"](tx.signature);
              });
              this.processing.set(tx.signature, task);
              return _context7.a(2, task);
          }
        }, _callee7, this);
      }));
      function processBugsTransaction(_x0) {
        return _processBugsTransaction2.apply(this, arguments);
      }
      return processBugsTransaction;
    }()
  }, {
    key: "_processBugsTransaction",
    value: function () {
      var _processBugsTransaction3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(tx, context) {
        var validation, signer, event, existing, policy, reporterVerified, _reference, _reference2, reference, result, _t4, _t5, _t6;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (this.verifyTransactionSignature(tx)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: 'Invalid Bugs transaction signature'
              });
            case 1:
              validation = validateBugsMessage(this.app, tx.returnMessage());
              if (validation.valid) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: validation.error
              });
            case 2:
              signer = this.returnSigner(tx);
              if (signer) {
                _context8.n = 3;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: 'Missing transaction signer'
              });
            case 3:
              event = {
                tx_sig: tx.signature,
                bug_id: validation.data.bug_id,
                request: validation.request,
                action: validation.data.action || '',
                previous_metadata_tx_sig: validation.data.previous_metadata_tx_sig || '',
                signer: signer,
                block_id: Number(context.block_id || 0),
                tx_ordinal: Number(context.tx_ordinal || 0),
                tx_timestamp: this.returnTimestamp(tx)
              };
              if (!this.app.BROWSER) {
                _context8.n = 4;
                break;
              }
              _t4 = this.clientBugs.get(event.bug_id);
              _context8.n = 6;
              break;
            case 4:
              _context8.n = 5;
              return this.database.getBug(event.bug_id);
            case 5:
              _t4 = _context8.v;
            case 6:
              existing = _t4;
              policy = this.authorityPolicy();
              reporterVerified = false;
              if (!(validation.request === 'create bug')) {
                _context8.n = 14;
                break;
              }
              _context8.p = 7;
              _context8.n = 8;
              return this.verifyRedSquareReference(validation.data);
            case 8:
              reference = _context8.v;
              _context8.n = 10;
              break;
            case 9:
              _context8.p = 9;
              _t5 = _context8.v;
              return _context8.a(2, {
                accepted: false,
                error: _t5.message || 'Invalid RedSquare reference'
              });
            case 10:
              reporterVerified = Boolean((_reference = reference) === null || _reference === void 0 ? void 0 : _reference.verified);
              if (!((_reference2 = reference) !== null && _reference2 !== void 0 && _reference2.verified && reference.reporter_publickey !== validation.data.reporter_publickey)) {
                _context8.n = 11;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: 'Reporter does not match the referenced RedSquare tweet'
              });
            case 11:
              if (!(existing && !canUpdateBug(policy, signer, existing))) {
                _context8.n = 12;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: 'Signer is not authorised to re-track this bug'
              });
            case 12:
              if (!(!existing && !canCreateBug(policy, signer, validation.data.reporter_publickey))) {
                _context8.n = 13;
                break;
              }
              return _context8.a(2, {
                accepted: false,
                error: 'Signer is not authorised to add this bug'
              });
            case 13:
              _context8.n = 16;
              break;
            case 14:
              if (canUpdateBug(policy, signer, existing)) {
                _context8.n = 16;
                break;
              }
              if (existing) {
                _context8.n = 15;
                break;
              }
              this.deferTransaction(tx, context);
              return _context8.a(2, {
                accepted: false,
                deferred: true,
                error: 'Bug create transaction has not arrived'
              });
            case 15:
              return _context8.a(2, {
                accepted: false,
                error: 'Signer is not authorised to update this bug'
              });
            case 16:
              if (!(existing && event.block_id === 0 && event.previous_metadata_tx_sig && event.previous_metadata_tx_sig !== existing.latest_metadata_tx_sig)) {
                _context8.n = 17;
                break;
              }
              this.deferTransaction(tx, context);
              return _context8.a(2, {
                accepted: false,
                deferred: true,
                error: 'Metadata predecessor has not arrived'
              });
            case 17:
              if (!this.app.BROWSER) {
                _context8.n = 18;
                break;
              }
              _t6 = this.applyClientEvent(validation, event, reporterVerified);
              _context8.n = 20;
              break;
            case 18:
              _context8.n = 19;
              return this.database.applyAcceptedEvent(validation, event, reporterVerified);
            case 19:
              _t6 = _context8.v;
            case 20:
              result = _t6;
              if (!result.accepted) {
                _context8.n = 22;
                break;
              }
              if (validation.request === 'create bug') {
                this.discoveredCandidates["delete"](event.bug_id);
              }
              if (!(!this.app.BROWSER && !context.restoring)) {
                _context8.n = 21;
                break;
              }
              _context8.n = 21;
              return this.archiveTransaction(tx, validation, context);
            case 21:
              this.app.connection.emit('bugs-updated', event.bug_id);
              if (!result.applied) {
                _context8.n = 22;
                break;
              }
              _context8.n = 22;
              return this.retryPendingEvents(event.bug_id);
            case 22:
              return _context8.a(2, result);
          }
        }, _callee8, this, [[7, 9]]);
      }));
      function _processBugsTransaction(_x1, _x10) {
        return _processBugsTransaction3.apply(this, arguments);
      }
      return _processBugsTransaction;
    }()
  }, {
    key: "deferTransaction",
    value: function deferTransaction(tx, context) {
      if (this.pendingEvents.size >= this.maxPendingEvents) {
        console.warn('[Bugs] pending event queue full; dropping oldest deferred transaction');
        this.pendingEvents["delete"](this.pendingEvents.keys().next().value);
      }
      this.pendingEvents.set(tx.signature, {
        tx: tx,
        context: context
      });
    }
  }, {
    key: "verifyRedSquareReference",
    value: function () {
      var _verifyRedSquareReference = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(data) {
        var resolved;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (this.redsquare.available('resolveTweet')) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, {
                verified: false
              });
            case 1:
              _context9.n = 2;
              return this.redsquare.resolveTweet({
                root_tx_sig: data.root_tx_sig,
                source_tx_sig: data.source_tx_sig
              });
            case 2:
              resolved = _context9.v;
              if (!(!resolved || resolved.root_tx_sig !== data.root_tx_sig || resolved.source_tx_sig !== data.source_tx_sig)) {
                _context9.n = 3;
                break;
              }
              throw new Error('RedSquare references do not resolve to the supplied thread');
            case 3:
              return _context9.a(2, _objectSpread(_objectSpread({}, resolved), {}, {
                verified: true
              }));
          }
        }, _callee9, this);
      }));
      function verifyRedSquareReference(_x11) {
        return _verifyRedSquareReference.apply(this, arguments);
      }
      return verifyRedSquareReference;
    }()
  }, {
    key: "applyClientEvent",
    value: function applyClientEvent(validation, event) {
      var _current$processed_si;
      var reporterVerified = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var current = this.clientBugs.get(event.bug_id);
      if ((current === null || current === void 0 ? void 0 : current.latest_metadata_tx_sig) === event.tx_sig || current !== null && current !== void 0 && (_current$processed_si = current.processed_signatures) !== null && _current$processed_si !== void 0 && _current$processed_si.includes(event.tx_sig)) {
        if (current.latest_metadata_tx_sig === event.tx_sig && Number(current.latest_metadata_block_id || 0) === 0 && event.block_id > 0) {
          current.latest_metadata_block_id = event.block_id;
          current.latest_metadata_tx_ordinal = event.tx_ordinal;
        }
        return {
          accepted: true,
          applied: false,
          duplicate: true
        };
      }
      if (current && !shouldApplyEvent(current, event)) {
        current.processed_signatures = this.appendClientEvent(current, event.tx_sig);
        return {
          accepted: true,
          applied: false,
          duplicate: false
        };
      }
      var processed = this.appendClientEvent(current, event.tx_sig);
      if (validation.request === 'create bug') {
        var data = validation.data;
        var bug = _objectSpread(_objectSpread(_objectSpread({}, current || {}), data), {}, {
          added_by_publickey: event.signer,
          reporter_verified: reporterVerified ? 1 : (current === null || current === void 0 ? void 0 : current.reporter_verified) || 0,
          tracked: 1,
          reply_count: (current === null || current === void 0 ? void 0 : current.reply_count) || 0,
          created_at: (current === null || current === void 0 ? void 0 : current.created_at) || event.tx_timestamp,
          updated_at: event.tx_timestamp,
          completed_at: data.status === 'completed' ? event.tx_timestamp : 0,
          latest_metadata_tx_sig: event.tx_sig,
          latest_metadata_previous_tx_sig: event.previous_metadata_tx_sig || '',
          latest_metadata_block_id: event.block_id,
          latest_metadata_tx_ordinal: event.tx_ordinal,
          latest_metadata_timestamp: event.tx_timestamp,
          processed_signatures: processed
        });
        this.clientBugs.set(event.bug_id, bug);
      } else {
        var _bug = _objectSpread(_objectSpread({}, current), {}, {
          processed_signatures: processed,
          updated_at: event.tx_timestamp
        });
        var _data = validation.data;
        var field = {
          'set-title': 'title',
          'set-status': 'status',
          'set-severity': 'severity',
          'set-priority': 'priority',
          'set-weight': 'weight',
          'set-assignee': 'assignee_publickey',
          untrack: 'tracked',
          retrack: 'tracked'
        }[_data.action];
        _bug[field] = _data.action === 'untrack' ? 0 : _data.action === 'retrack' ? 1 : _data[field];
        if (_data.action === 'set-status') _bug.completed_at = _data.status === 'completed' ? event.tx_timestamp : 0;
        _bug.latest_metadata_tx_sig = event.tx_sig;
        _bug.latest_metadata_previous_tx_sig = event.previous_metadata_tx_sig || '';
        _bug.latest_metadata_block_id = event.block_id;
        _bug.latest_metadata_tx_ordinal = event.tx_ordinal;
        _bug.latest_metadata_timestamp = event.tx_timestamp;
        this.clientBugs.set(event.bug_id, _bug);
      }
      return {
        accepted: true,
        applied: true,
        duplicate: false
      };
    }
  }, {
    key: "appendClientEvent",
    value: function appendClientEvent(current, txSig) {
      var signatures = [].concat(_toConsumableArray((current === null || current === void 0 ? void 0 : current.processed_signatures) || []), [txSig]);
      return _toConsumableArray(new Set(signatures)).slice(-this.maxClientEventsPerBug);
    }
  }, {
    key: "retryPendingEvents",
    value: function () {
      var _retryPendingEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(bugId) {
        var retry, _iterator, _step, _step$value, signature, pending, _t7;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              retry = _toConsumableArray(this.pendingEvents.entries()).filter(function (_ref) {
                var _msg$data, _msg$data2;
                var _ref2 = _slicedToArray(_ref, 2),
                  pending = _ref2[1];
                var msg = pending.tx.returnMessage();
                return (((_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.bug_id) || ((_msg$data2 = msg.data) === null || _msg$data2 === void 0 ? void 0 : _msg$data2.root_tx_sig)) === bugId;
              });
              _iterator = _createForOfIteratorHelper(retry);
              _context0.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context0.n = 4;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2), signature = _step$value[0], pending = _step$value[1];
              this.pendingEvents["delete"](signature);
              _context0.n = 3;
              return this.processBugsTransaction(pending.tx, pending.context);
            case 3:
              _context0.n = 2;
              break;
            case 4:
              _context0.n = 6;
              break;
            case 5:
              _context0.p = 5;
              _t7 = _context0.v;
              _iterator.e(_t7);
            case 6:
              _context0.p = 6;
              _iterator.f();
              return _context0.f(6);
            case 7:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 5, 6, 7]]);
      }));
      function retryPendingEvents(_x12) {
        return _retryPendingEvents.apply(this, arguments);
      }
      return retryPendingEvents;
    }()
  }, {
    key: "archiveTransaction",
    value: function () {
      var _archiveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(tx, validation, context) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              tx.optional || (tx.optional = {});
              tx.optional.bugs_block_id = Number(context.block_id || 0);
              tx.optional.bugs_tx_ordinal = Number(context.tx_ordinal || 0);
              _context1.n = 1;
              return this.app.storage.saveTransaction(tx, {
                field1: 'Bugs',
                field2: validation.data.bug_id,
                field3: validation.request,
                block_id: Number(context.block_id || 0)
              }, 'localhost', context.confirmed ? context.blk : null);
            case 1:
              if (!context.confirmed) {
                _context1.n = 2;
                break;
              }
              _context1.n = 2;
              return this.app.storage.updateTransaction(tx, {
                field1: 'Bugs',
                field2: validation.data.bug_id,
                field3: validation.request,
                block_id: Number(context.block_id || 0)
              }, 'localhost', 1);
            case 2:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function archiveTransaction(_x13, _x14, _x15) {
        return _archiveTransaction.apply(this, arguments);
      }
      return archiveTransaction;
    }()
  }, {
    key: "restoreProjection",
    value: function () {
      var _restoreProjection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _this5 = this;
        var limit, createdEarlierThan, _loop, _ret;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              if (!(this.restored || this.restoring || this.app.BROWSER)) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              this.restoring = true;
              limit = 1000;
              createdEarlierThan = 0;
              _context11.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var query, transactions, page, _iterator2, _step2, _tx$optional, _tx$optional2, tx, nextCursor, _t8;
                return _regenerator().w(function (_context10) {
                  while (1) switch (_context10.p = _context10.n) {
                    case 0:
                      query = {
                        field1: 'Bugs',
                        limit: limit
                      };
                      if (createdEarlierThan > 0) query.created_earlier_than = createdEarlierThan;
                      _context10.n = 1;
                      return new Promise(function (resolve) {
                        _this5.app.storage.loadTransactions(query, resolve, 'localhost');
                      });
                    case 1:
                      transactions = _context10.v;
                      page = Array.isArray(transactions) ? transactions : [];
                      page.sort(function (a, b) {
                        return _this5.returnTimestamp(b) - _this5.returnTimestamp(a);
                      });
                      _iterator2 = _createForOfIteratorHelper(page);
                      _context10.p = 2;
                      _iterator2.s();
                    case 3:
                      if ((_step2 = _iterator2.n()).done) {
                        _context10.n = 5;
                        break;
                      }
                      tx = _step2.value;
                      _context10.n = 4;
                      return _this5.processBugsTransaction(tx, {
                        restoring: true,
                        block_id: Number(((_tx$optional = tx.optional) === null || _tx$optional === void 0 ? void 0 : _tx$optional.bugs_block_id) || 0),
                        tx_ordinal: Number(((_tx$optional2 = tx.optional) === null || _tx$optional2 === void 0 ? void 0 : _tx$optional2.bugs_tx_ordinal) || 0)
                      });
                    case 4:
                      _context10.n = 3;
                      break;
                    case 5:
                      _context10.n = 7;
                      break;
                    case 6:
                      _context10.p = 6;
                      _t8 = _context10.v;
                      _iterator2.e(_t8);
                    case 7:
                      _context10.p = 7;
                      _iterator2.f();
                      return _context10.f(7);
                    case 8:
                      if (!(page.length < limit)) {
                        _context10.n = 9;
                        break;
                      }
                      return _context10.a(2, 0);
                    case 9:
                      nextCursor = Math.min.apply(Math, _toConsumableArray(page.map(function (tx) {
                        return _this5.returnTimestamp(tx);
                      })));
                      if (!(!Number.isSafeInteger(nextCursor) || nextCursor <= 0 || nextCursor === createdEarlierThan)) {
                        _context10.n = 10;
                        break;
                      }
                      return _context10.a(2, 0);
                    case 10:
                      createdEarlierThan = nextCursor;
                    case 11:
                      return _context10.a(2);
                  }
                }, _loop, null, [[2, 6, 7, 8]]);
              });
            case 3:
              if (!true) {
                _context11.n = 6;
                break;
              }
              return _context11.d(_regeneratorValues(_loop()), 4);
            case 4:
              _ret = _context11.v;
              if (!(_ret === 0)) {
                _context11.n = 5;
                break;
              }
              return _context11.a(3, 6);
            case 5:
              _context11.n = 3;
              break;
            case 6:
              this.restored = true;
            case 7:
              _context11.p = 7;
              this.restoring = false;
              return _context11.f(7);
            case 8:
              return _context11.a(2);
          }
        }, _callee10, this, [[2,, 7, 8]]);
      }));
      function restoreProjection() {
        return _restoreProjection.apply(this, arguments);
      }
      return restoreProjection;
    }()
  }, {
    key: "processRedSquareTransaction",
    value: function () {
      var _processRedSquareTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(tx) {
        var message, data, root, rootTxSig, bug, reporter, candidate, _t9;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              message = tx.returnMessage();
              data = message.data || {};
              root = isRootTweetMessage(message);
              if (root) {
                _context12.n = 6;
                break;
              }
              _t9 = data.thread_id;
              if (_t9) {
                _context12.n = 2;
                break;
              }
              _context12.n = 1;
              return this.redsquare.resolveReplyRoot(tx)["catch"](function () {
                return '';
              });
            case 1:
              _t9 = _context12.v;
            case 2:
              rootTxSig = _t9;
              if (rootTxSig) {
                _context12.n = 3;
                break;
              }
              return _context12.a(2);
            case 3:
              if (!this.app.BROWSER) {
                _context12.n = 4;
                break;
              }
              bug = this.clientBugs.get(rootTxSig);
              if ((bug === null || bug === void 0 ? void 0 : bug.tracked) === 1) {
                bug.reply_count = Number(bug.reply_count || 0) + 1;
                bug.updated_at = Math.max(Number(bug.updated_at || 0), this.returnTimestamp(tx));
                this.app.connection.emit('bugs-updated', rootTxSig);
              }
              _context12.n = 5;
              break;
            case 4:
              _context12.n = 5;
              return this.database.noteReply(rootTxSig, this.returnTimestamp(tx));
            case 5:
              return _context12.a(2);
            case 6:
              if (containsBugHashtag(data.text)) {
                _context12.n = 7;
                break;
              }
              return _context12.a(2);
            case 7:
              reporter = this.returnSigner(tx);
              candidate = {
                root_tx_sig: tx.signature,
                source_tx_sig: tx.signature,
                reporter_publickey: reporter,
                title: this.titleFromTweet(data.text)
              };
              if (!this.discoveredCandidates.has(tx.signature) && this.discoveredCandidates.size >= this.maxDiscoveredCandidates) {
                this.discoveredCandidates["delete"](this.discoveredCandidates.keys().next().value);
              }
              this.discoveredCandidates.set(tx.signature, candidate);
              this.app.connection.emit('bugs-candidate-discovered', tx.signature);
              if (!(this.app.BROWSER && this.isEnabled() && reporter === this.publicKey && !this.clientBugs.has(tx.signature) && !this.autoCapturePending.has(tx.signature))) {
                _context12.n = 10;
                break;
              }
              this.autoCapturePending.add(tx.signature);
              _context12.p = 8;
              _context12.n = 9;
              return this.submitCreate(candidate);
            case 9:
              _context12.p = 9;
              this.autoCapturePending["delete"](tx.signature);
              return _context12.f(9);
            case 10:
              return _context12.a(2);
          }
        }, _callee11, this, [[8,, 9, 10]]);
      }));
      function processRedSquareTransaction(_x16) {
        return _processRedSquareTransaction.apply(this, arguments);
      }
      return processRedSquareTransaction;
    }()
  }, {
    key: "titleFromTweet",
    value: function titleFromTweet(text) {
      var line = String(text || '').split(/\r?\n/).map(function (value) {
        return value.replace(/(^|\s)#bug(?=$|[\s.,!?;:()[\]{}])/gi, ' ').trim();
      }).find(Boolean);
      return (line || 'Bug report').slice(0, 180);
    }
  }, {
    key: "createSignedTransaction",
    value: function () {
      var _createSignedTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(request, data) {
        var recipients,
          tx,
          _iterator3,
          _step3,
          publicKey,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              recipients = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : [];
              _context13.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 1:
              tx = _context13.v;
              tx.msg = {
                module: this.name,
                request: request,
                data: data
              };
              _iterator3 = _createForOfIteratorHelper(new Set(recipients.filter(Boolean)));
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  publicKey = _step3.value;
                  if (publicKey !== this.publicKey) tx.addTo(publicKey);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _context13.n = 2;
              return tx.sign();
            case 2:
              if (tx.signature) {
                _context13.n = 3;
                break;
              }
              throw new Error('Unable to sign Bugs transaction');
            case 3:
              return _context13.a(2, tx);
          }
        }, _callee12, this);
      }));
      function createSignedTransaction(_x17, _x18) {
        return _createSignedTransaction.apply(this, arguments);
      }
      return createSignedTransaction;
    }()
  }, {
    key: "submitCreate",
    value: function () {
      var _submitCreate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
        var _this$clientBugs$get;
        var payload, tx, _t0, _t1, _t10, _t11, _t12, _t13, _t14, _t15, _t16, _t17, _t18, _t19, _t20;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _t0 = data.root_tx_sig;
              _t1 = data.root_tx_sig;
              _t10 = data.source_tx_sig || data.root_tx_sig;
              _t11 = data.title;
              _t12 = data.status || 'open';
              _t13 = data.severity || 'medium';
              _t14 = data.priority || 'normal';
              if (!Number.isSafeInteger(Number(data.weight))) {
                _context14.n = 1;
                break;
              }
              _t15 = Number(data.weight);
              _context14.n = 3;
              break;
            case 1:
              _context14.n = 2;
              return this.nextWeight();
            case 2:
              _t15 = _context14.v;
            case 3:
              _t16 = _t15;
              _t17 = data.reporter_publickey || '';
              _t18 = data.assignee_publickey || '';
              _t19 = data.note_tx_sig || '';
              _t20 = ((_this$clientBugs$get = this.clientBugs.get(data.root_tx_sig)) === null || _this$clientBugs$get === void 0 ? void 0 : _this$clientBugs$get.latest_metadata_tx_sig) || '';
              payload = {
                bug_id: _t0,
                root_tx_sig: _t1,
                source_tx_sig: _t10,
                title: _t11,
                status: _t12,
                severity: _t13,
                priority: _t14,
                weight: _t16,
                reporter_publickey: _t17,
                assignee_publickey: _t18,
                note_tx_sig: _t19,
                previous_metadata_tx_sig: _t20
              };
              _context14.n = 4;
              return this.createSignedTransaction('create bug', payload, [payload.reporter_publickey, payload.assignee_publickey]);
            case 4:
              tx = _context14.v;
              return _context14.a(2, this.deliverSignedTransaction(tx));
          }
        }, _callee13, this);
      }));
      function submitCreate(_x19) {
        return _submitCreate.apply(this, arguments);
      }
      return submitCreate;
    }()
  }, {
    key: "submitUpdate",
    value: function () {
      var _submitUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(rootTxSig, action) {
        var value,
          bug,
          payload,
          key,
          tx,
          delivered,
          _args15 = arguments;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              value = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : null;
              bug = this.clientBugs.get(rootTxSig);
              payload = {
                bug_id: rootTxSig,
                action: action,
                previous_metadata_tx_sig: (bug === null || bug === void 0 ? void 0 : bug.latest_metadata_tx_sig) || ''
              };
              key = {
                'set-title': 'title',
                'set-status': 'status',
                'set-severity': 'severity',
                'set-priority': 'priority',
                'set-weight': 'weight',
                'set-assignee': 'assignee_publickey'
              }[action];
              if (key) payload[key] = value;
              _context15.n = 1;
              return this.createSignedTransaction('update bug', payload, [bug === null || bug === void 0 ? void 0 : bug.reporter_publickey, action === 'set-assignee' ? value : bug === null || bug === void 0 ? void 0 : bug.assignee_publickey]);
            case 1:
              tx = _context15.v;
              _context15.n = 2;
              return this.deliverSignedTransaction(tx);
            case 2:
              delivered = _context15.v;
              if (!(action === 'set-status')) {
                _context15.n = 3;
                break;
              }
              _context15.n = 3;
              return this.replyToBug(bug, "status -> ".concat(STATUS_LABELS[value] || value));
            case 3:
              return _context15.a(2, delivered);
          }
        }, _callee14, this);
      }));
      function submitUpdate(_x20, _x21) {
        return _submitUpdate.apply(this, arguments);
      }
      return submitUpdate;
    }()
  }, {
    key: "deliverSignedTransaction",
    value: function () {
      var _deliverSignedTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(tx) {
        var before, local, serialized, _t21;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              before = this.app.BROWSER ? new Map(this.clientBugs) : null;
              _context16.n = 1;
              return this.processBugsTransaction(tx, {
                optimistic: true
              });
            case 1:
              local = _context16.v;
              if (local.accepted) {
                _context16.n = 2;
                break;
              }
              throw new Error(local.error || 'Bugs transaction was rejected locally');
            case 2:
              _context16.p = 2;
              serialized = tx.serialize_to_web(this.app);
              this.app.network.sendRequestAsTransaction('bugs transaction', {
                transaction: serialized
              }, null, this.serverPeer || undefined, true);
              _context16.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              return _context16.a(2, tx);
            case 4:
              _context16.p = 4;
              _t21 = _context16.v;
              if (before) this.clientBugs = before;
              this.app.connection.emit('bugs-updated');
              throw _t21;
            case 5:
              return _context16.a(2);
          }
        }, _callee15, this, [[2, 4]]);
      }));
      function deliverSignedTransaction(_x22) {
        return _deliverSignedTransaction.apply(this, arguments);
      }
      return deliverSignedTransaction;
    }()
  }, {
    key: "createBugFromComposer",
    value: function () {
      var _createBugFromComposer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(metadata) {
        var result, resolved;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return this.redsquare.composeRoot({
                text: '',
                images: true,
                prompt: 'Describe the bug'
              });
            case 1:
              result = _context17.v;
              if (!(result !== null && result !== void 0 && result.signature || result !== null && result !== void 0 && result.tx)) {
                _context17.n = 3;
                break;
              }
              _context17.n = 2;
              return this.normalizeTweetContext(result.tx || result);
            case 2:
              resolved = _context17.v;
              return _context17.a(2, this.submitCreate(_objectSpread(_objectSpread({}, metadata), resolved)));
            case 3:
              return _context17.a(2, result);
          }
        }, _callee16, this);
      }));
      function createBugFromComposer(_x23) {
        return _createBugFromComposer.apply(this, arguments);
      }
      return createBugFromComposer;
    }()
  }, {
    key: "openCapture",
    value: function () {
      var _openCapture = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(context) {
        var values;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              if (this.editor) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2, navigateWindow('/bugs'));
            case 1:
              _context18.n = 2;
              return this.normalizeTweetContext(context);
            case 2:
              values = _context18.v;
              return _context18.a(2, this.editor.open('capture', values));
          }
        }, _callee17, this);
      }));
      function openCapture(_x24) {
        return _openCapture.apply(this, arguments);
      }
      return openCapture;
    }()
  }, {
    key: "captureTweet",
    value: function () {
      var _captureTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(context, metadata) {
        var reference, noteTxSig, _note$tx, note;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              _context19.n = 1;
              return this.normalizeTweetContext(context);
            case 1:
              reference = _context19.v;
              noteTxSig = '';
              if (!metadata.note) {
                _context19.n = 3;
                break;
              }
              _context19.n = 2;
              return this.redsquare.composeReply({
                root_tx_sig: reference.root_tx_sig,
                parent_tx_sig: reference.source_tx_sig,
                text: metadata.note,
                publishImmediately: true
              });
            case 2:
              note = _context19.v;
              noteTxSig = (note === null || note === void 0 ? void 0 : note.signature) || (note === null || note === void 0 || (_note$tx = note.tx) === null || _note$tx === void 0 ? void 0 : _note$tx.signature) || '';
            case 3:
              return _context19.a(2, this.submitCreate(_objectSpread(_objectSpread(_objectSpread({}, metadata), reference), {}, {
                note_tx_sig: noteTxSig
              })));
          }
        }, _callee18, this);
      }));
      function captureTweet(_x25, _x26) {
        return _captureTweet.apply(this, arguments);
      }
      return captureTweet;
    }()
  }, {
    key: "normalizeTweetContext",
    value: function () {
      var _normalizeTweetContext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(context) {
        var _tx$returnMessage, tx, msg, data;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              if (!(context !== null && context !== void 0 && context.root_tx_sig && context !== null && context !== void 0 && context.source_tx_sig)) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2, context);
            case 1:
              if (!(context !== null && context !== void 0 && context.transaction || context !== null && context !== void 0 && context.tx || context !== null && context !== void 0 && context.signature)) {
                _context20.n = 2;
                break;
              }
              tx = context.transaction || context.tx || context;
              msg = ((_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || context.message || {};
              data = msg.data || {};
              return _context20.a(2, {
                root_tx_sig: data.thread_id || tx.signature || context.signature,
                source_tx_sig: tx.signature || context.signature,
                reporter_publickey: this.returnSigner(tx) || context.reporter_publickey || '',
                title: context.title || this.titleFromTweet(data.text)
              });
            case 2:
              return _context20.a(2, this.redsquare.resolveTweet(context));
          }
        }, _callee19, this);
      }));
      function normalizeTweetContext(_x27) {
        return _normalizeTweetContext.apply(this, arguments);
      }
      return normalizeTweetContext;
    }()
  }, {
    key: "replyToBug",
    value: function () {
      var _replyToBug = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(bug) {
        var text,
          _args21 = arguments;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              text = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : '';
              return _context21.a(2, this.redsquare.composeReply({
                root_tx_sig: bug.root_tx_sig,
                parent_tx_sig: bug.source_tx_sig,
                text: text,
                publishImmediately: Boolean(text)
              }));
          }
        }, _callee20, this);
      }));
      function replyToBug(_x28) {
        return _replyToBug.apply(this, arguments);
      }
      return replyToBug;
    }()
  }, {
    key: "requestInformation",
    value: function () {
      var _requestInformation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(bug) {
        var reply;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              _context22.n = 1;
              return this.redsquare.composeReply({
                root_tx_sig: bug.root_tx_sig,
                parent_tx_sig: bug.source_tx_sig,
                prompt: 'What additional information is required?'
              });
            case 1:
              reply = _context22.v;
              if (reply) {
                _context22.n = 2;
                break;
              }
              return _context22.a(2, null);
            case 2:
              return _context22.a(2, this.submitUpdate(bug.root_tx_sig, 'set-status', 'needs_information'));
          }
        }, _callee21, this);
      }));
      function requestInformation(_x29) {
        return _requestInformation.apply(this, arguments);
      }
      return requestInformation;
    }()
  }, {
    key: "updateBugFields",
    value: function () {
      var _updateBugFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(rootTxSig, current, values) {
        var changes, transactions, _i, _changes, _changes$_i, action, field, _t22;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              changes = [['set-title', 'title'], ['set-status', 'status'], ['set-severity', 'severity'], ['set-priority', 'priority'], ['set-assignee', 'assignee_publickey']];
              transactions = [];
              _i = 0, _changes = changes;
            case 1:
              if (!(_i < _changes.length)) {
                _context23.n = 4;
                break;
              }
              _changes$_i = _slicedToArray(_changes[_i], 2), action = _changes$_i[0], field = _changes$_i[1];
              if (!(String(current[field] || '') !== String(values[field] || ''))) {
                _context23.n = 3;
                break;
              }
              _t22 = transactions;
              _context23.n = 2;
              return this.submitUpdate(rootTxSig, action, values[field] || '');
            case 2:
              _t22.push.call(_t22, _context23.v);
            case 3:
              _i++;
              _context23.n = 1;
              break;
            case 4:
              return _context23.a(2, transactions);
          }
        }, _callee22, this);
      }));
      function updateBugFields(_x30, _x31, _x32) {
        return _updateBugFields.apply(this, arguments);
      }
      return updateBugFields;
    }()
  }, {
    key: "handleWorkflowAction",
    value: function () {
      var _handleWorkflowAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(bug, action, value) {
        var list, _index, target, _t23;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              _context24.p = 0;
              if (!(action === 'edit')) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2, this.editor.open('edit', bug));
            case 1:
              if (!(action === 'request-information')) {
                _context24.n = 2;
                break;
              }
              return _context24.a(2, this.requestInformation(bug));
            case 2:
              if (!(action === 'move-up' || action === 'move-down')) {
                _context24.n = 5;
                break;
              }
              _context24.n = 3;
              return this.loadBugs({
                view: bug.status === 'completed' ? 'completed' : 'active',
                sort: 'weight'
              });
            case 3:
              list = _context24.v;
              _index = list.findIndex(function (row) {
                return row.root_tx_sig === bug.root_tx_sig;
              });
              target = list[_index + (action === 'move-up' ? -1 : 1)];
              if (!target) {
                _context24.n = 4;
                break;
              }
              return _context24.a(2, this.moveBug(bug.root_tx_sig, target.root_tx_sig, list.map(function (row) {
                return row.root_tx_sig;
              })));
            case 4:
              return _context24.a(2, null);
            case 5:
              if (!(action === 'untrack')) {
                _context24.n = 8;
                break;
              }
              _context24.n = 6;
              return sconfirm('Remove this bug from Bugs? The RedSquare thread will remain unchanged.');
            case 6:
              if (_context24.v) {
                _context24.n = 7;
                break;
              }
              return _context24.a(2, null);
            case 7:
              return _context24.a(2, this.submitUpdate(bug.root_tx_sig, 'untrack'));
            case 8:
              return _context24.a(2, this.submitUpdate(bug.root_tx_sig, action, value));
            case 9:
              _context24.p = 9;
              _t23 = _context24.v;
              this.showError(_t23);
              return _context24.a(2, null);
          }
        }, _callee23, this, [[0, 9]]);
      }));
      function handleWorkflowAction(_x33, _x34, _x35) {
        return _handleWorkflowAction.apply(this, arguments);
      }
      return handleWorkflowAction;
    }()
  }, {
    key: "moveBug",
    value: function () {
      var _moveBug = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(movedId, targetId) {
        var _this6 = this,
          _list,
          _list2;
        var orderedIds,
          list,
          from,
          target,
          _list$splice,
          _list$splice2,
          moved,
          insertion,
          index,
          weight,
          i,
          desired,
          _args25 = arguments;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              orderedIds = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : [];
              list = orderedIds.length ? orderedIds.map(function (id) {
                return _this6.clientBugs.get(id);
              }).filter(Boolean) : _toConsumableArray(this.clientBugs.values()).filter(function (bug) {
                return bug.tracked === 1;
              }).sort(function (a, b) {
                return Number(a.weight) - Number(b.weight);
              });
              from = list.findIndex(function (bug) {
                return bug.root_tx_sig === movedId;
              });
              target = list.findIndex(function (bug) {
                return bug.root_tx_sig === targetId;
              });
              if (!(from < 0 || target < 0 || from === target)) {
                _context25.n = 1;
                break;
              }
              return _context25.a(2, null);
            case 1:
              _list$splice = list.splice(from, 1), _list$splice2 = _slicedToArray(_list$splice, 1), moved = _list$splice2[0];
              insertion = list.findIndex(function (bug) {
                return bug.root_tx_sig === targetId;
              });
              list.splice(from < target ? insertion + 1 : insertion, 0, moved);
              index = list.findIndex(function (bug) {
                return bug.root_tx_sig === movedId;
              });
              weight = midpointWeight((_list = list[index - 1]) === null || _list === void 0 ? void 0 : _list.weight, (_list2 = list[index + 1]) === null || _list2 === void 0 ? void 0 : _list2.weight, DEFAULT_WEIGHT);
              if (!(weight != null)) {
                _context25.n = 2;
                break;
              }
              return _context25.a(2, this.submitUpdate(movedId, 'set-weight', weight));
            case 2:
              i = 0;
            case 3:
              if (!(i < list.length)) {
                _context25.n = 5;
                break;
              }
              desired = (i + 1) * 100;
              if (!(Number(list[i].weight) !== desired)) {
                _context25.n = 4;
                break;
              }
              _context25.n = 4;
              return this.submitUpdate(list[i].root_tx_sig, 'set-weight', desired);
            case 4:
              i++;
              _context25.n = 3;
              break;
            case 5:
              return _context25.a(2, true);
          }
        }, _callee24, this);
      }));
      function moveBug(_x36, _x37) {
        return _moveBug.apply(this, arguments);
      }
      return moveBug;
    }()
  }, {
    key: "nextWeight",
    value: function () {
      var _nextWeight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var rows;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              rows = _toConsumableArray(this.clientBugs.values());
              return _context26.a(2, rows.length ? Math.max.apply(Math, _toConsumableArray(rows.map(function (bug) {
                return Number(bug.weight || 0);
              }))) + 100 : DEFAULT_WEIGHT);
          }
        }, _callee25, this);
      }));
      function nextWeight() {
        return _nextWeight.apply(this, arguments);
      }
      return nextWeight;
    }()
  }, {
    key: "canCurrentUserEdit",
    value: function canCurrentUserEdit(bug) {
      return canUpdateBug(this.authorityPolicy(), this.publicKey, bug);
    }
  }, {
    key: "loadBugs",
    value: function () {
      var _loadBugs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
        var filters,
          rows,
          _iterator4,
          _step4,
          bug,
          _args27 = arguments;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              filters = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
              if (this.app.BROWSER) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2, this.database.listBugs(filters));
            case 1:
              _context27.n = 2;
              return this.peerRequest('bugs query', filters)["catch"](function () {
                return null;
              });
            case 2:
              rows = _context27.v;
              if (!Array.isArray(rows)) {
                _context27.n = 3;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(rows);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  bug = _step4.value;
                  this.clientBugs.set(bug.root_tx_sig, bug);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              return _context27.a(2, rows);
            case 3:
              return _context27.a(2, this.filterClientBugs(filters));
          }
        }, _callee26, this);
      }));
      function loadBugs() {
        return _loadBugs.apply(this, arguments);
      }
      return loadBugs;
    }()
  }, {
    key: "loadBug",
    value: function () {
      var _loadBug = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(rootTxSig) {
        var row;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              if (this.app.BROWSER) {
                _context28.n = 1;
                break;
              }
              return _context28.a(2, this.database.getBug(rootTxSig));
            case 1:
              _context28.n = 2;
              return this.peerRequest('bugs get', {
                root_tx_sig: rootTxSig
              })["catch"](function () {
                return null;
              });
            case 2:
              row = _context28.v;
              if (row !== null && row !== void 0 && row.root_tx_sig) this.clientBugs.set(row.root_tx_sig, row);
              return _context28.a(2, row || this.clientBugs.get(rootTxSig) || null);
          }
        }, _callee27, this);
      }));
      function loadBug(_x38) {
        return _loadBug.apply(this, arguments);
      }
      return loadBug;
    }()
  }, {
    key: "peerRequest",
    value: function peerRequest(request, data) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var timeout = setTimeout(function () {
          return reject(new Error('Bugs service did not respond'));
        }, 6000);
        _this7.app.network.sendRequestAsTransaction(request, data, function (response) {
          clearTimeout(timeout);
          resolve(response);
        }, _this7.serverPeer || undefined);
      });
    }
  }, {
    key: "filterClientBugs",
    value: function filterClientBugs() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var rows = _toConsumableArray(this.clientBugs.values()).filter(function (bug) {
        return bug.tracked === 1;
      }).filter(function (bug) {
        return filters.view === 'all' ? true : filters.view === 'completed' ? bug.status === 'completed' : bug.status !== 'completed';
      }).filter(function (bug) {
        return !filters.status || bug.status === filters.status;
      }).filter(function (bug) {
        return !filters.severity || bug.severity === filters.severity;
      }).filter(function (bug) {
        return !filters.priority || bug.priority === filters.priority;
      }).filter(function (bug) {
        return !filters.assignee_publickey || bug.assignee_publickey === filters.assignee_publickey;
      }).filter(function (bug) {
        return !filters.reporter_publickey || bug.reporter_publickey === filters.reporter_publickey;
      }).filter(function (bug) {
        return !filters.search || bug.title.toLowerCase().includes(filters.search.toLowerCase());
      });
      var rank = function rank(values, value) {
        return values.indexOf(value);
      };
      var sort = {
        updated: function updated(a, b) {
          return Number(b.updated_at) - Number(a.updated_at);
        },
        created: function created(a, b) {
          return Number(b.created_at) - Number(a.created_at);
        },
        severity: function severity(a, b) {
          return rank(['critical', 'high', 'medium', 'low'], a.severity) - rank(['critical', 'high', 'medium', 'low'], b.severity);
        },
        priority: function priority(a, b) {
          return rank(['urgent', 'high', 'normal', 'low'], a.priority) - rank(['urgent', 'high', 'normal', 'low'], b.priority);
        },
        weight: function weight(a, b) {
          return Number(a.weight) - Number(b.weight);
        }
      }[filters.sort || 'weight'];
      return rows.sort(sort || function (a, b) {
        return Number(a.weight) - Number(b.weight);
      });
    }
  }, {
    key: "showError",
    value: function showError(error) {
      var message = (error === null || error === void 0 ? void 0 : error.message) || String(error);
      this.app.connection.emit('saito-header-update-message', {
        msg: message,
        timeout: 5000
      });
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/web");
      var mod = this;
      var page = function page(req, res) {
        var social = _objectSpread(_objectSpread({}, mod.social), {}, {
          url: "".concat(req.protocol, "://").concat(req.headers.host).concat(req.originalUrl)
        });
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        res.send(index(app, mod, app.build_number, social));
      };
      expressapp.use('/bugs', express["static"](webdir));
      expressapp.get('/bugs', page);
      expressapp.get('/bugs/:bug_id', page);
    }
  }]);
}(ModTemplate);
module.exports = Bugs;